//------------------------------------------------------ funciones
import {
  subscribeTable,
  createRow,
  updateRow,
  deleteRow,
} from "../supabaseRealtime";
import { cacheStore } from "../cache";
import { etiquetaDeFicha } from "../../shared/empresa";
import { textoDeEstado, estaActiva } from "./estado";

const TABLA = "vehiculos";

const enriquecer = (vh) => {
  const empresasMap = cacheStore.empresas?.map || {};
  const empresa = empresasMap[String(vh.empresa)];

  // Ver estado.js: el campo trae "1"/"true"/"0"/"false"/""/null, y el
  // chequeo anterior daba "Activo" para todo texto no vacío — incluido
  // "false".
  const estado = textoDeEstado(vh.estado);

  return {
    ...vh,
    label: `${vh.id} (${vh.marca})`.trim(),
    nombreEmpresa: etiquetaDeFicha(vh.empresa, empresa),
    estadoReal: estado,
  };
};

export const subscribeVehiculos = (callback) =>
  subscribeTable(TABLA, (rows) => callback(rows.map(enriquecer)));

/* Mismo problema que arriba: `x.estado` a secas daba verdadero para el
 * texto "false". Ahora se usa el mismo criterio que la etiqueta, para que
 * la lista y el contador no puedan discrepar. */
export const getVehiculosActivos = (lista) =>
  lista.filter((x) => estaActiva(x.estado));

export const createVehiculo = ({ id, ...data }) => createRow(TABLA, id, data);

export const updateVehiculo = (id, data) => updateRow(TABLA, id, data);

export const deleteVehiculo = (id) => deleteRow(TABLA, id);
